import { IAssessmentCmsContent, IAssessmentData, ICheckoutDetails, ILeadSubmitOtp } from "@/interfaces/IAssessmentData";
import { useEffect, useState } from "react"
import { BookConsultCats } from "../leadForm/BookConsultCats";
import { ILeadCategories } from "@/interfaces";
import { BookConsultSubCats } from "../leadForm/BookConsultSubCats";
import { AssessmentContext } from "@/libs/context/AssessmentContext";
import { API } from "@/libs/helpers/http-client";
import { AssessmentQuestion } from "./AssessmentQuestions";
import { AssessmentReport } from "./AssessmentReport";
import { AssessmentStart } from "./AssessmentStart";
import { useRouter } from "next/router";

type props = {
    assessmentData: IAssessmentData
}
export function AssessmentMain({ assessmentData }: props) {
    const [getFormIndex, setFormIndex] = useState(5);
    const [apiError, setApiError] = useState("");
    const [loader, setLoader] = useState(false)
    const [questionList, setQuestionList] = useState([]);
    const [isConfirm, setIsConfirm] = useState(false);
    const [assessmentResult, setAssessmentResult] = useState<any>({});
    const [assessmentCmsContent, setAssessmentCmsContent] = useState<IAssessmentCmsContent | any>({});
    const [isOtpVerified, setOtpVerified] = useState(false);
    const router = useRouter();
    const [subcategories, setSubCategories] = useState<ILeadCategories>({
        id: 0,
        category_name: "",
        image: "",
        color: "",
        icon: "",
        cms_cat_id: 0,
        subcat: []
    });

    const [checkoutDetails, setCheckoutDetails] = useState<ICheckoutDetails>({
        assessment_id: "",
        product_id: "",
        country: "India",
        telephone: "",
        first_name: "",
        last_name: "",
        pincode: "",
        city: "",
        landmark: "",
        state: "",
        address: ""
    });

    const [cats, setCats] = useState<{ category_id: number; subcategory_id: number; }>({
        category_id: 1,
        subcategory_id: 1,
    });
    const [verifyOtp, setVerifyOtp] = useState<ILeadSubmitOtp>({
        otp: '',
        unique_key: ''
    });
    const getQuestions = async (data: { category_id: number; subcategory_id: number; }) => {
        setLoader(true);
        try {
            const result: any = await API.post(`/api/assessment`, data, {
                headers: {
                    "requesttype": "questions"
                }
            });
            if (result && result.status == 200) {
                setQuestionList(result.data.data);
            } else setApiError(result.message);
        } catch (error: any) {
            if (error.response && error.response.data)
                setApiError(error.response.data);
            else if (error.message)
                setApiError(error.message);
            else
                setApiError(error);
        }
        setLoader(false);
    };

    const submitAssessment = async (otp: number) => {
        try {
            const _body = {
                data: {
                    ...verifyOtp,
                    category_id: cats.category_id.toString() || '',
                    subcategory_id: cats.subcategory_id.toString() || '',
                    otp: otp
                }
            }
            const result: any = await API.post(`/api/assessment`, _body, {
                headers: {
                    "requesttype": "submit"
                }
            });
            if (result && result.data.status === true) {
                setIsConfirm(result.data && result.data.statusCode === 'DUPLICATE');
                setOtpVerified(true)
                return true
            } else setApiError(result.data.message);
        } catch (error: any) {
            if (error.response && error.response.data)
                setApiError(error.response.data);
            else if (error.message)
                setApiError(error.message);
            else
                setApiError(error);
        }
    };
    const sendOtp = async (phone: string) => {
        try {
            const result: any = await API.post(`/api/assessment`, { phone }, {
                headers: {
                    "requesttype": "sendOtp"
                }
            });
            if (result && result.status == 200) {
                setVerifyOtp!({ ...verifyOtp!, unique_key: result.data.data.unique_key })
            } else setApiError!(result.message);
        } catch (error: any) {
            if (error.response && error.response.data)
                setApiError!(error.response.data);
            else if (error.message)
                setApiError!(error.message);
            else
                setApiError!(error);
        }
    };
    const submitAssessmentForm = async (body: any) => {
        try {
            const _body = {
                data: {
                    questionList: body,
                    unique_key: verifyOtp.unique_key,
                    category_id: cats.category_id.toString() || '',
                    subcategory_id: cats.subcategory_id.toString() || '',
                }
            };

            const result: any = await API.post(`/api/assessment`, _body, {
                headers: {
                    "requesttype": "submitAssessmentForm"
                }
            });
            if (result && result.status == 200) {
                getAssessmentResultById(result.data.data.assessment_id);
                return true;
            } else setApiError(result.data.data.message);
        } catch (error: any) {
            if (error.response && error.response.data)
                setApiError(error.response.data);
            else if (error.message)
                setApiError(error.message);
            else
                setApiError(error);
        }
    }
    const getAssessmentResultById = async (assessmentId: string) => {
        try {
            const _body = {
                data: {
                    assessment_id: assessmentId
                }
            }
            const result: any = await API.post(`/api/assessment`, _body, {
                headers: {
                    "requesttype": "getAssessmentResultById"
                }
            });
            if (result && result.status == 200) {
                setAssessmentResult(result.data.data);
                getAssessmentContentByCMSCatId(subcategories?.cms_cat_id?.toString() || "");
                setCheckoutDetails({ ...checkoutDetails, assessment_id: assessmentId, product_id: (result.data.data?.product_plan[0]?.bolt_product_id || "") });
                return true;
            } else setApiError!(result.message);
        } catch (error: any) {
            if (error.response && error.response.data)
                setApiError!(error.response.data);
            else if (error.message)
                setApiError!(error.message);
            else
                setApiError!(error);
        }
    };

    const getAssessmentContentByCMSCatId = async (catId: string) => {
        try {
            const _body = {
                catId
            }
            const result: any = await API.post(`/api/assessment`, _body, {
                headers: {
                    "requesttype": "getAssessmentContentByCMSCatId"
                }
            });
            if (result && result.status == 200) {
                setAssessmentCmsContent(result.data);
                return true;
            } else setApiError!(result.message);
        } catch (error: any) {
            if (error.response && error.response.data)
                setApiError!(error.response.data);
            else if (error.message)
                setApiError!(error.message);
            else
                setApiError!(error);
        }
    }

    const getCityStateFromPincode = async (pinCode: string) => {
        try {
            const result: any = await API.post(`/api/pincode`, { pinCode }, {
                headers: {
                    "requesttype": "pinCode"
                }
            });
            if (result && result.status == 200) {
                const data = result.data?.data[0]
                setCheckoutDetails({ ...checkoutDetails, city: data.city, state: data.state });
            } else setApiError!(result.message);
        } catch (error: any) {
            if (error.response && error.response.data)
                setApiError!(error.response.data);
            else if (error.message)
                setApiError!(error.message);
            else
                setApiError!(error);
        }
    };
    const createJuspayLink = async (body: ICheckoutDetails) => {
        try {
            const result: any = await API.post(`/api/assessment`, body, {
                headers: {
                    "requesttype": "createJuspayLink"
                }
            });
            if (result && result.status == 200) {
                result.data.web_link && router.push(`${result.data.web_link}`)
            } else setApiError!(result.message);
        } catch (error: any) {
            if (error.response && error.response.data)
                setApiError!(error.response.data);
            else if (error.message)
                setApiError!(error.message);
            else
                setApiError!(error);
        }
    };

    useEffect(() => {
        getFormIndex === 3 && getQuestions(cats);
        setApiError("")
    }, [getFormIndex])
    const getForm = () => {
        switch (getFormIndex) {
            case 1:
                return <BookConsultCats categories={assessmentData.leadCategories} setSubCategories={setSubCategories} isAssessment={true} />
            case 2:
                return <BookConsultSubCats subcategories={subcategories} isAssessment={true} />
            case 3:
                return <AssessmentQuestion questionList={questionList} isOtpVerified={isOtpVerified} />
            case 4:
                return <AssessmentReport assessmentResult={assessmentResult} assessmentCmsContent={assessmentCmsContent} />
            case 5:
                return <AssessmentStart />
            default: <></>

        }
    }
    return (
        <AssessmentContext.Provider value={{
            setFormIndex,
            setCats,
            setApiError,
            cats,
            setVerifyOtp,
            verifyOtp,
            submitAssessment,
            sendOtp,
            loader,
            isConfirm,
            setIsConfirm,
            submitAssessmentForm,
            getAssessmentResultById,
            getCityStateFromPincode,
            checkoutDetails,
            setCheckoutDetails,
            apiError,
            createJuspayLink
        }}>
            {getForm()}
        </AssessmentContext.Provider>
    )
}